import { REVENUE_DATA_ERROR, GETTING_REVENUE_DATA, GET_REVENUE_DATA, GET_FINANCE_DATA, GETTING_FINANCE_DATA, FINANCE_DATA_ERROR } from "../types"

const initialState = {
    revenueData: [],
    revenuePeriod: 'monthly',
    loadingRevenue: true,
    revenueError: null,
    financeData: null,
    loadingFinance: true,
    financeError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
    switch(action.type){
        case GETTING_REVENUE_DATA:
        return {
            ...state,
            loadingRevenue: action.payload,
        }
        case GET_REVENUE_DATA:
        return{
            ...state,
            loadingRevenue: false,
            revenueError: null,
            revenueData: action.payload.data,
            revenuePeriod: action.payload.period
        }
        case REVENUE_DATA_ERROR:
        return{
            ...state,
            loadingRevenue: false,
            revenueError: action.payload
        }
        case GETTING_FINANCE_DATA:
        return {
            ...state,
            loadingFinance: action.payload,
        }
        case GET_FINANCE_DATA:
        return{
            ...state,
            loadingFinance: false,
            financeError: null,
            financeData: action.payload
        }
        case FINANCE_DATA_ERROR:
        return{
            ...state,
            loadingFinance: false,
            financeError: action.payload
        }
        default: return state
    }
}
